import React, {useMemo} from "react";
import "./Dimmer.scss";

export interface DimmerProps {
  type?: "alert" | "action" | "page";
  position?: "fixed" | "absolute" | "relative" | "static" | "sticky";
  children: React.ReactNode;
  className?: string;
}

function Dimmer({
  type,
  position = "fixed",
  className,
  children,
}: DimmerProps): React.JSX.Element {
  const styles = useMemo(() => ({
    position,
    zIndex: type === "alert" ? 1000 : 99,
    backgroundColor: "rgba(36,36,36,0.7)",
  }), [position, type]);

  return (
    <div
      className={`Dimmer ${className || ""}`}
      style={styles}
      >
      {children}
    </div>
  )
}

export default React.memo(Dimmer);
